package amazon.lastmile.inject

import app.nestbridge.feature.designcatalog.ui.DesignCatalogUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DesignCatalogUiFactory::class)
public interface AppNestbridgeFeatureDesigncatalogUiDesignCatalogUiFactory {
  @Provides
  @IntoSet
  public fun provideDesignCatalogUiFactoryFactoryMultibinding(designCatalogUiFactory: DesignCatalogUiFactory): Ui.Factory = designCatalogUiFactory
}
